module.exports = __webpack_public_path__ + "static/img/G-Arg.442d86f5.png";